import * as React from "react";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ApplyModel } from "../../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { IsaAllowance } from "../../../../Common/ISA/PaymentsIn/IsaAllowance";
import { RegularPayment } from "../../../../Common/PaymentsIn/RegularPayment/RegularPayment";
import { SinglePayment } from "../../../../Common/PaymentsIn/SinglePayment/SinglePayment";
import { PaymentType, processTypeEnum } from "../../../../Common/Resource/Contents";
import { nbPaymentsInMessages } from "../../../Resource/Contents";
import { TransferIn } from "../../../../Common/PaymentsIn/TransferIn/TransferIn";
import { getQueryParameters } from "../../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
import { RestrictionStore } from "../../../../Common/Restrictions/Variable";
import { RestrictionHelper } from "../../../../../../../Shared/Common/RestrictionHelper";
import { BankAccountAction } from "../../../../Common/PaymentsIn/BankAccount/BankAccountAction";
import { ProcessTypeHelper } from "../../../../Common/Helpers/ProcessTypeHelper";
import { IsaDeclaration } from "../../../../Common/ISA/PaymentsIn/IsaDeclaration";
import { inUseBankAccountForApply } from "../../../../Common/PaymentsIn/BankAccount/BankAccountHelper";
import { string } from "prop-types";

interface IPaymentsInProps extends IProcessComponentProps {
    data: ApplyModel;
    processType: ProcessType;
}

interface IPaymentsInState {}

export class PaymentsIn extends ProcessComponent<IPaymentsInProps, IPaymentsInState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp, isReview, processType } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
            hasPaymentMethod: true,
            isReview: isReview,
            onSaveNewBankAccountInstruction: (bankAccountInstruction) => {
                bankAccountInstruction.OwnerHierarchyId = data.OwnerHierarchyId;
                BankAccountAction.saveBankInstruction(
                    bankAccountInstruction,
                    data.ClientDetails?.ActorId,
                    ProcessTypeHelper.getProcessTypeEnum(processType),
                    (savedBankAccountInstruction) => {
                        const changes = [...data.BankAccountInstructions, ...[savedBankAccountInstruction]];
                        this.onDataChange(onChange, changes, data, "BankAccountInstructions");
                    }
                );
            },
            onRemoveBankAccountInstruction: (bankAccountInstruction) => {
                BankAccountAction.removeBankInstruction(bankAccountInstruction, () => {
                    const changes = (data.BankAccountInstructions || []).filter(
                        (x) => x.AccountNumber != bankAccountInstruction.AccountNumber
                    );
                    this.onDataChange(onChange, { BankAccountInstructions: changes }, data);
                });
            },
            inUseBankAccountInstruction: inUseBankAccountForApply(data),
        };
    };

    public isValid(): boolean {
        let isValid = super.isValid();
        isValid = isValid && this.atLeastOneContribution();
        if (!this.atLeastOneContribution()) {
            this.props.showErrorMsgPopUp([nbPaymentsInMessages.atLeastOneContribution]);
        }
        return isValid;
    }

    private atLeastOneContribution(): boolean {
        const { data } = this.props;

        return (
            data.IsaModel.ClientSinglePayment?.Money?.Amount > 0 ||
            data.IsaModel.ThirdPartySinglePayment?.Money?.Amount > 0 ||
            data.IsaModel.ClientRegularPayment?.Money?.Amount > 0 ||
            data.IsaModel.ThirdPartyRegularPayment?.Money?.Amount > 0 ||
            data.IsaModel.IsaTransfers?.length > 0
        );
    }

    public render(): JSX.Element {
        const { ClientDetails, AllBankAccounts, BankAccountInstructions, IsaModel } = this.props.data;
        const { data, onChange } = this.props;
        const claccountId = getQueryParameters()["claccountId"];

        return (
            <div>
                <h2>Payments in</h2>
                <SinglePayment
                    {...this.getProps("IsaModel")}
                    clientInfo={ClientDetails}
                    checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                    subAccountType={SubAccountType.StocksIsa}
                    bankAccounts={AllBankAccounts}
                    hasPaymentMethod={true}
                    bankAccountInstructions={BankAccountInstructions}
                    processType={claccountId ? processTypeEnum.NewBusinessExistingClient : processTypeEnum.NewBusiness}
                />
                <hr />
                <RegularPayment
                    {...this.getProps("IsaModel")}
                    clientInfo={ClientDetails}
                    bankAccounts={AllBankAccounts}
                    bankAccountInstructions={BankAccountInstructions}
                    checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                    subAccountType={SubAccountType.StocksIsa}
                    hasPaymentMethod={true}
                    hasContinue={true}
                    hasIndexation={false}
                    processType={claccountId ? processTypeEnum.NewBusinessExistingClient : processTypeEnum.NewBusiness}
                />
                <hr />
                <TransferIn
                    subAccountType={SubAccountType.StocksIsa}
                    data={IsaModel.IsaTransfers}
                    claccountId={data.ShellHeadClAccountId ? data.ShellHeadClAccountId : data.AccountCreated?.AccountId}
                    jouneryType={claccountId ? processTypeEnum.NewBusinessExistingClient : processTypeEnum.NewBusiness}
                    onChange={(changes) =>
                        this.onDataChange(
                            (changes) => this.onDataChange(onChange, changes, data, "IsaModel"),
                            changes,
                            IsaModel
                        )
                    }
                    disabled={
                        RestrictionStore.transferDisabled() &&
                        RestrictionHelper.shouldHandleRestriction(this.props.processType)
                    }
                    isReview={this.props.isReview}
                    showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                    isPost={false}
                    onRef={(ref) => this.appendChild(ref)}
                    accountServiceProposition={this.props.data.AccountServiceProposition}
                />
                {data?.IsaModel?.IsaAllowance && <IsaAllowance cssWrapper="mt-54" {...this.getProps("IsaModel")} />}
                <IsaDeclaration {...this.getProps("IsaModel")} />
            </div>
        );
    }
}
